import React from 'react';

const LayoutFooter = () => (
  <footer className="w-full py-6 md:py-8 border-t border-indigo-800 bg-indigo-700 dark:border-teal-800 dark:bg-teal-700">
    <div className="container flex flex-col items-center justify-between gap-4 px-4 md:flex-row md:px-6">
      <div className="text-sm text-white dark:text-gray-200">
        © {new Date().getFullYear()} EC-Compliance. Todos los derechos reservados. Tu éxito es nuestro compromiso.
      </div>
      <nav className="flex flex-wrap justify-center gap-4 sm:gap-6">
        <a href="/#servicios" className="text-sm text-white hover:text-indigo-200 transition-colors dark:text-gray-200 dark:hover:text-white">Servicios</a>
        <a href="/#soluciones" className="text-sm text-white hover:text-indigo-200 transition-colors dark:text-gray-200 dark:hover:text-white">Soluciones</a>
        <a href="/#contacto" className="text-sm text-white hover:text-indigo-200 transition-colors dark:text-gray-200 dark:hover:text-white">Contacto</a>
        <a href="/como-convertir-pdf-vucem" className="text-sm text-white hover:text-indigo-200 transition-colors dark:text-gray-200 dark:hover:text-white">Guía PDF VUCEM</a>
        <a href="/que-es-manifestacion-de-valor-electronica" className="text-sm text-white hover:text-indigo-200 transition-colors dark:text-gray-200 dark:hover:text-white">¿Qué es la MVE?</a>
      </nav>
    </div>
  </footer>
);

export default LayoutFooter;